<div class="wizard-container">
    <app-quotation *ngIf="currentStep === 1" (complete)="nextStep()" [textListInfo]="textListInfo" [data]="data" [aliasProducto]="aliasProducto"></app-quotation>
    <app-data-info *ngIf="currentStep === 2" (complete)="nextStep()" (backStep)="goBackStep($event)" (formData)="handleFormData($event)"></app-data-info>
    <app-payment *ngIf="currentStep === 3"  (backStep)="goBackStep($event)" (formDataPayment)="handlePayment($event)" [htmlConsents]="htmlConsents"></app-payment>
</div>

